import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useState } from "react";
import { TouchableOpacity } from "react-native";
import { List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { Checkbox } from "../Checkbox";

type SavedMemoryItemWebProps = {
	item: {
		text: string;
	};
	isSelected: boolean;
	onPress: (item: { text: string }) => void;
	onDelete: (selectedListItems: string[]) => void;
};

const SavedMemoryItemWeb = ({
	item,
	isSelected,
	onPress,
	onDelete,
}: SavedMemoryItemWebProps) => {
	const [isHovered, setIsHovered] = useState(false);
	const theme = useAppTheme();
	return (
		<List.Item
			onHoverIn={() => setIsHovered(true)}
			onHoverOut={() => setIsHovered(false)}
			title={item.text}
			titleNumberOfLines={4}
			onPress={() => {
				onPress(item);
			}}
			left={() => (
				<Box width={48} height={48} justifyContent="center" alignItems="center">
					<Checkbox status={isSelected ? "checked" : "unchecked"} />
				</Box>
			)}
			right={() => (
				<Box width={48} height={48} justifyContent="center" alignItems="center">
					{isHovered && (
						<TouchableOpacity onPress={() => onDelete([item.text])}>
							<Icon
								name="delete-outline"
								size={24}
								color={theme.colors.onSurfaceVariant}
							/>
						</TouchableOpacity>
					)}
				</Box>
			)}
		/>
	);
};

export default SavedMemoryItemWeb;
